// src/pages/VerifyPhone.js
import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const VerifyPhone = () => {
  const {
    maskedPhone,
    setMaskedPhone,
  } = useContext(AuthContext);

  const navigate = useNavigate();

  const sendVerificationCode = async (e) => {
    if (e) e.preventDefault();
    try {
      // Phone is NOT sent from the client — the backend reads it from the DB
      // using the authenticated JWT (loginId/username). The client cannot
      // influence which number receives the OTP. ISO 27001 A.8.5 / SOC 2 CC6.1
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/trader/send-code`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      });

      const data = await response.json();

      if (data.success) {
        // Update masked phone from server response so it displays correctly
        // even if React state was cleared by a page refresh
        if (data.masked) setMaskedPhone(data.masked);
        toast.success(`Verification code sent to ${data.masked || maskedPhone}`);
        navigate('/enter-code'); // ✅ Go to the next page
      } else {
        toast.error(data.error || 'Failed to send code');
      }
    } catch (err) {
      console.error(err);
      toast.error('Server error sending code');
    }
  };

  return (
    <form className="login-form" onSubmit={sendVerificationCode}>
      <h2>Verify Your Phone</h2>
      <p>Code will be sent to: <strong>{maskedPhone}</strong></p>
      <button type="submit">
        Send Code
      </button>
    </form>
  );
};

export default VerifyPhone;
